const Id = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 8.5A2.5 2.5 0 0 1 7 6h7.982a2.5 2.5 0 0 1 2.021 1.03l2.546 3.5a2.5 2.5 0 0 1 0 2.94l-2.546 3.5A2.5 2.5 0 0 1 14.982 18H7a2.5 2.5 0 0 1-2.5-2.5zM7 7a1.5 1.5 0 0 0-1.5 1.5v7A1.5 1.5 0 0 0 7 17h7.982c.48 0 .93-.23 1.213-.618l2.545-3.5a1.5 1.5 0 0 0 0-1.764l-2.545-3.5A1.5 1.5 0 0 0 14.982 7z"
      clipRule="evenodd"
    />
  </>
)
export default Id
